module.exports = __webpack_public_path__ + "static/media/GenerateCode.8dd0dcdf.svg";